/**
 * Each game's first-play tutorial (2026-11-03, Spencer's call: a guided first
 * move). A hand shows the first move on the real game, with a few words, and
 * the child then does it. Keyed by game type, as in the sheets.
 *
 * A step: `target` (a CSS selector for what the hand points at; games mark
 * their right answer with data-tutorial="1", and the second thing with "2"),
 * `gesture` ("tap", "drag" to `to`, "swipe" across), `text`, and `done`:
 * "tap" ends the step when the target is tapped, "move" when the child's first
 * try is scored, right or wrong, "moved" once they've moved the pointer a good
 * way or pressed an arrow key (steering Item Fall's chipmunk), "gone" once the
 * target has been moved (a piece dragged out of the tray).
 */
const ANSWER = '[data-tutorial="1"]';
const SECOND = '[data-tutorial="2"]';

export const TUTORIALS = {
  "Bubble Pop": [{ target: ANSWER, gesture: "tap", text: "Pop the bubble that matches the word", done: "move" }],
  "Whack-A-Mole": [{ target: ANSWER, gesture: "tap", text: "Tap the one that matches the word", done: "move" }],
  Matching: [
    { target: ".match2_card:not(.match2_card--up)", gesture: "tap", text: "Tap a card to turn it over", done: "tap" },
    { target: SECOND, gesture: "tap", text: "Now find the card that matches it", done: "tap" },
  ],
  "Word To Image": [
    { target: ANSWER, gesture: "tap", text: "Tap a word", done: "tap" },
    { target: SECOND, gesture: "tap", text: "Now tap its picture", done: "move" },
  ],
  Wordless: [{ target: ANSWER, gesture: "tap", text: "Listen, then tap the picture you heard", done: "move" }],
  "Good Guess": [{ target: ANSWER, gesture: "tap", text: "Tap every picture of the word", done: "move" }],
  Counting: [{ target: ANSWER, gesture: "tap", text: "Tap each one to count it", done: "move" }],
  "Item Fall": [
    { target: ".ifg_catcher", gesture: "swipe", text: "Move the chipmunk under the picture that matches the word", done: "moved" },
  ],
  "Verb Activity": [{ target: ANSWER, gesture: "tap", text: "Hop onto the picture that matches the word", done: "move" }],
  "From Me To You": [
    { target: ANSWER, gesture: "tap", text: "Tap who does it", done: "tap" },
    { target: SECOND, gesture: "tap", text: "Then tap who it's done to", done: "move" },
  ],
  Crocodile: [{ target: ANSWER, to: SECOND, gesture: "drag", text: "Drag the sign that makes it true", done: "move" }],
  // its first piece isn't scored until the problem is full: done when it's moved
  "Solve It": [{ target: ANSWER, to: SECOND, gesture: "drag", text: "Drag the pieces into the problem", done: "gone" }],
  // any card or word shows the move without giving the answer away
  History: [
    { target: ".tl2_hand .dragkit_tile", to: ".tl2_line", gesture: "drag", text: "Drag a card onto the timeline, where it fits", done: "move" },
  ],
  "Fill In The Blank": [
    { target: ".FITB-bankSlot .dragkit_tile", to: ".FITB-blank", gesture: "drag", text: "Drag the word that fills the blank", done: "move" },
  ],
  // a book opens on its cover, which has no words to tap yet
  "Story Book": [
    { target: '.reader2_controls [aria-label="Next page"]', gesture: "tap", text: "Tap here to turn the page", done: "tap" },
    { target: ".reader2_vocab button", gesture: "tap", text: "Tap a word to hear it", done: "tap" },
  ],
};

export const tutorialFor = (gameType) => TUTORIALS[gameType] ?? null;
